module.exports = __webpack_public_path__ + "static/media/img3.51d2a60e.jpg";